import SpaceBetween from '@cloudscape-design/components/space-between';
import Input from '@cloudscape-design/components/input';
import Textarea from '@cloudscape-design/components/textarea';
import Button from '@cloudscape-design/components/button';
import Toggle from '@cloudscape-design/components/toggle';

interface SearchFormProps {
  placeholder: string;
  /** Absent when the entity has no bulk search: no toggle, single field only. */
  bulkPlaceholder?: string;
  bulkMode: boolean;
  onBulkModeChange: (checked: boolean) => void;
  searchValue: string;
  onSearchValueChange: (value: string) => void;
  onSearch: () => void;
}

export const SearchForm = ({
  placeholder,
  bulkPlaceholder,
  bulkMode,
  onBulkModeChange,
  searchValue,
  onSearchValueChange,
  onSearch,
}: SearchFormProps) => {
  // Guarded on the placeholder rather than the flag alone, so a tab without
  // bulk cannot be left in it by stale state.
  const bulk = bulkMode && bulkPlaceholder !== undefined;

  return (
    <SpaceBetween size="m">
      {bulk ? (
        <SpaceBetween size="s">
          <Textarea
            value={searchValue}
            onChange={({ detail }) => onSearchValueChange(detail.value)}
            placeholder={bulkPlaceholder}
            rows={5}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Toggle
              checked={bulkMode}
              onChange={({ detail }) => onBulkModeChange(detail.checked)}
            >
              Bulk search mode
            </Toggle>
            <Button variant="primary" iconName="search" onClick={onSearch}>
              Search
            </Button>
          </div>
        </SpaceBetween>
      ) : (
        <SpaceBetween size="s">
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <Input
                value={searchValue}
                onChange={({ detail }) => onSearchValueChange(detail.value)}
                onKeyDown={({ detail }) => {
                  if (detail.keyCode === 13) onSearch();
                }}
                placeholder={placeholder}
                type="search"
              />
            </div>
            <Button variant="primary" iconName="search" onClick={onSearch}>
              Search
            </Button>
          </div>
          {bulkPlaceholder !== undefined && (
            <Toggle
              checked={bulkMode}
              onChange={({ detail }) => onBulkModeChange(detail.checked)}
            >
              Bulk search mode
            </Toggle>
          )}
        </SpaceBetween>
      )}
    </SpaceBetween>
  );
};
